import './main.css';

import { VueQueryPlugin } from '@tanstack/vue-query';
import { toast } from '@beonit/adaptive-raindrop';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import App from './App.vue';
import { setSessionExpiredHandler } from '@shared/infrastructure/http/http-client.js';
import { useAuthStore } from '@shared/presentation/auth/store.js';
import { router } from '@shared/presentation/router/router.js';

/**
 * Bootstrap.
 *
 * Nothing blocks the first paint: the session is resolved by the guard on the
 * first navigation, and the public config is fetched by whoever needs it. The
 * only thing wired up here is what happens when the session expires, because
 * that decision belongs to the application and not to the HTTP client.
 */
const app = createApp(App);

app.use(createPinia());
app.use(VueQueryPlugin, {
  queryClientConfig: {
    defaultOptions: {
      queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
    },
  },
});

setSessionExpiredHandler(() => {
  const auth = useAuthStore();
  auth.reset();
  toast.error('Tu sesión ha caducado. Vuelve a entrar.');
  void router.push({ name: 'login' });
});

app.use(router);
app.mount('#app');
